import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import AlertMain from "./AlertMain";
import StatusComp from "../../../components/StatusComp";

const AdminAlertTypesComp = () => {
  const location = useLocation();
  const { type, datas, data } = location?.state;
  const navigate = useNavigate();
  const createdAt = moment().format("DD-MM-YYYY,h:mm A");
  return (
    <div className="">
      <AlertMain ind={"ind"} adminType={true} />
    </div>
  );
};

export default AdminAlertTypesComp;
